<template>
  <Page class="queryView">
    <div class="queryView-main">
      <a-form class="flex-form" style="flex: 1" layout="inline" :form="form" :colon="false">
        <a-row style="margin-top: 20px">
          <a-col :span="6">
            <a-form-item label="姓名">
              <a-input
                :max-length="64"
                allow-clear
                v-model="form.travelerName"
                placeholder="请输入姓名"
                @pressEnter="doQuery(1)"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="状态">
              <a-select v-model="form.status" placeholder="请选择" @change="doQuery(1)">
                <a-select-option :value="0">未处理</a-select-option>
                <a-select-option :value="1">已处理</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" style="text-align: right;">
            <a-button class="app-btn" type="primary" ghost style="margin-right: 20px;" @click="doQuery(1)">
              立即搜索
            </a-button>
            <a-button class="app-btn" type="default" style="margin-right: 40px;" @click="resetAndQuery">
              重置搜索
            </a-button>
          </a-col>
        </a-row>
      </a-form>

      <a-table
        class="mt-5"
        :row-key="
          (record, index) => {
            return index
          }
        "
        bordered
        :loading="tableLoading"
        :columns="tableColumns"
        :dataSource="dataSource"
        @change="handleTableChange$qv"
        :pagination="{
          current: pageNumber,
          pageSize: pageSize,
          total: countTotal,
          showSizeChanger: true,
          showQuickJumper: true,
        }"
      />
    </div>
    <a-modal title="备注" :visible="visible" :confirm-loading="confirmLoading" @ok="handleOk" @cancel="handleCancel">
      <div>
        <a-textarea v-model="itemInfo.remarks" :rows="4" placeholder="请输入备注" />
      </div>
    </a-modal>
  </Page>
</template>
<script>
import Page from '@/components/Page'
import { queryViewMixin, toolMixin } from '@/utils/mixin'

export default {
  mixins: [queryViewMixin, toolMixin],
  components: {
    Page,
  },
  data() {
    const tableColumns = [
      {
        title: '序号',
        width: '80px',
        align: 'center',
        customRender: (text, row, index) => {
          return <span>{this.pageSize * (this.pageNumber - 1) + (index + 1)} </span>
        },
      },
      {
        title: '目的地',
        align: 'center',
        dataIndex: 'destination',
      },
      {
        title: '姓名',
        align: 'center',
        dataIndex: 'travelerName',
      },
      {
        title: '手机号',
        align: 'center',
        dataIndex: 'travelerMobile',
      },
      {
        title: '提交需求时间',
        align: 'center',
        dataIndex: 'createTime',
      },
      {
        title: '操作人',
        align: 'center',
        width: '100px',
        dataIndex: 'handlerUserId',
      },
      {
        title: '操作时间',
        align: 'center',
        width: '200px',
        dataIndex: 'updateTime',
      },
      {
        title: '备注',
        align: 'center',
        width: '200px',
        dataIndex: 'remarks',
        customRender: (text, row) => {
          return (
            <span
              style="cursor:pointer;color: #4099ff"
              onclick={() => {
                this.updateRemark(row)
              }}
            >
              {text || '无'}
            </span>
          )
        },
      },

      {
        title: '状态',
        width: '160px',
        align: 'center',
        dataIndex: 'status',
        customRender: text => {
          return <span>{text == 1 ? '已处理' : text == 0 ? '待处理' : '-'}</span>
        },
      },
      {
        title: '操作',
        width: '160px',
        align: 'center',
        customRender: (text, row) => {
          return row.status == 0 ? (
            <span
              onclick={() => {
                this.updateStatus(row)
              }}
              style="cursor:pointer;color: #079a92"
            >
              已联系客户
            </span>
          ) : (
            '-'
          )
        },
      },
    ]
    return {
      pageNumber: 1,
      pageSize: 10,
      countTotal: 0,
      refundAmount: 0,
      tableLoading: false,
      confirmLoading: false,
      visible: false,
      tableColumns: tableColumns,
      itemInfo: {
        remarks: '',
        applyId: null,
        status: null,
      },

      dataSource: [],
      plainOptions: [
        {
          label: '张三',
          value: '1',
        },
        {
          label: '李四',
          value: '2',
        },
      ],
      checkedList: [],
      form: {
        travelerName: '',
        status: null,
      },
      time: [],
    }
  },
  methods: {
    handleCancel() {
      this.visible = false
      this.itemInfo.remarks = ''
      this.itemInfo.status = null
      this.itemInfo.applyId = null
    },
    handleOk() {
      this.$axios
        .post(`/po/admin/travel/custom/update`, {
          applyId: this.itemInfo.applyId,
          status: 1,
          remarks: this.itemInfo.remarks,
        })
        .then(res => {
          if (res.success) {
            this.$message.success('操作成功')
            this.visible = false
            this.doQuery()
          }
        })
    },
    updateStatus(row) {
      this.itemInfo = JSON.parse(JSON.stringify(row))
      this.visible = true
    },
    updateRemark(row) {
      this.itemInfo = JSON.parse(JSON.stringify(row))
      this.visible = true
    },
    getParams() {
      return {
        ...this.form,
      }
    },
    async doQuery(page) {
      if (page) {
        this.pageNumber = page
      }
      this.tableLoading = true
      const res = await this.$axios.get(`/po/admin/travel/custom/list`, {
        params: {
          ...this.getParams(),
          page: this.pageNumber,
          limit: this.pageSize,
        },
      })
      this.countTotal = Number(res.count)
      this.dataSource = res.data
      this.tableLoading = false
    },
    resetAndQuery() {
      this.form.status = null
      this.form.travelerName = ''
      this.doQuery()
    },
  },
  async mounted() {
    this.doQuery()
  },
}
</script>
<style lang="less" scoped>
.bm-view {
  height: 600px;
}
.refund {
  width: 100%;
  margin: 0 auto;
  .refund-title {
    line-height: 30px;
  }
  .refund-pay {
    width: 100%;
    min-height: 50px;
    padding: 0 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .refund-pay-item {
      display: flex;
      line-height: 30px;
      .refund-pay-item-title {
        width: 80px;
      }
    }
  }
  .refund-amount {
    width: 100%;
    min-height: 100px;
    .refund-checkbox-group {
      width: 100%;
      display: flex;
      padding: 20px;
    }
    .refund-amount-item {
      display: flex;
      line-height: 30px;
      padding: 20px;
    }
  }
  .refund-remark {
    width: 100%;
    min-height: 100px;
  }
}
</style>
